import { Card, CardBody, Col } from 'reactstrap'
import { BarCharts } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { barChartData } from '../../../../Data/Charts/ApexChart/ApexChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const BarChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={BarCharts} />
        <CardBody>
          <div id="basic-bar">
            <ReactApexChart options={barChartData} series={barChartData.series} type="bar" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BarChart